(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) return;

			$(this).addClass("slider_started");

			const announcementId = $(this).data("announcement-id");

			// read settings from data attributes on this element
			const autoEnabled =
				$(this).data("autoClickEnabled") === true ||
				$(this).data("autoClickEnabled") === "true";
			const clickDelay =
				parseInt($(this).data("autoClickDelay") || 0, 10) * 1000; // ms
			const idleDelay =
				parseInt($(this).data("idleDelay") || 0, 10) * 1000; // ms

			// initialize Swiper
			const swiper = new Swiper(`.announcement-js-${announcementId}`, {
				loop: autoEnabled,
				navigation: {
					nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
					prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
				},
			});

			// autoplay logic
			if (autoEnabled && clickDelay > 0) {
				let autoTimer = null;
				let idleTimer = null;

				const startAuto = () => {
					clearInterval(autoTimer);
					autoTimer = setInterval(() => {
						if (swiper.isEnd && !swiper.params.loop) {
							swiper.slideTo(0);
						} else {
							swiper.slideNext();
						}
					}, clickDelay);
				};

				const stopAuto = () => {
					clearInterval(autoTimer);
					autoTimer = null;
				};

				const resetIdle = () => {
					stopAuto();
					clearTimeout(idleTimer);
					idleTimer = setTimeout(() => {
						startAuto();
					}, idleDelay);
				};

				// start autoplay immediately
				startAuto();

				// pause on any interaction inside swiper
				swiper.el.addEventListener("click", resetIdle);
				swiper.el.addEventListener("touchstart", resetIdle);
				swiper.el.addEventListener("keydown", resetIdle);

				// also pause if nav arrows are clicked
				const prevBtn = document.querySelector(
					`#shopify-section-${announcementId} .announcement-btn-prev`
				);
				const nextBtn = document.querySelector(
					`#shopify-section-${announcementId} .announcement-btn-next`
				);

				if (prevBtn) prevBtn.addEventListener("click", resetIdle);
				if (nextBtn) nextBtn.addEventListener("click", resetIdle);
			}
		});
	};

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
